class ThicknessRange extends HTMLElement {
  constructor() {
    super();

    this.sliders = this.querySelectorAll(
      '[data-range-slider] input[type="range"]'
    );
    if (this.sliders.length !== 2) return;
    [this.minSlider, this.maxSlider] = this.sliders;
    this.rangeTrack = this.querySelector('[data-range-selected]');
    this.checkboxes = Array.from(
      this.querySelectorAll('input[type="checkbox"]')
    ).filter((cb) => !isNaN(parseFloat(cb.value)));

    this.values = this.checkboxes.map((cb) => parseFloat(cb.value));
    this.minAttr = Math.min(...this.values);
    this.maxAttr = Math.max(...this.values);
    this.step = parseFloat(this.minSlider.step || '0.01');
    this.span = this.maxAttr - this.minAttr;

    this.sliders.forEach((slider) => {
      slider.min = this.minAttr;
      slider.max = this.maxAttr;
      slider.step = this.step;
    });

    this.setInitialSliderValues();
    this.updateTrackFromChecked();

    this.minSlider.addEventListener(
      'input',
      this.handleSliderChange.bind(this)
    );
    this.maxSlider.addEventListener(
      'input',
      this.handleSliderChange.bind(this)
    );

 
this.isDragging = false;

this.minSlider.addEventListener('pointerdown', () => {
  this.isDragging = true;
});
this.maxSlider.addEventListener('pointerdown', () => {
  this.isDragging = true;
});

document.addEventListener('pointerup', () => {
  if (this.isDragging) {
    this.isDragging = false;
    this.handleSliderChange(); // Final update after drag ends
  }
});

 
  }

  setInitialSliderValues() {
    const initiallyChecked = this.checkboxes.filter((cb) => cb.checked);
    //console.log(initiallyChecked, 'initial Check');

    if (initiallyChecked.length > 0) {
      const checkedVals = initiallyChecked.map((cb) => parseFloat(cb.value));
      this.minSlider.value = Math.min(...checkedVals);
      this.maxSlider.value = Math.max(...checkedVals);

      if (this.minSlider.value === this.maxSlider.value) {
        const fallbackMin = parseFloat(this.maxSlider.value) - this.step * 10;
        this.minSlider.value = Math.max(fallbackMin, this.minAttr).toFixed(5);
      }
    } else {
      this.minSlider.value = this.minAttr;
      this.maxSlider.value = this.maxAttr;
    }
    this.updateLabels();
  }

  updateCheckboxes() {
    const currentMin = parseFloat(this.minSlider.value);
    const currentMax = parseFloat(this.maxSlider.value);

    this.checkboxes.forEach((cb) => {
      const val = parseFloat(cb.value);
      cb.checked = val >= currentMin && val <= currentMax;
    });
  }

  updateTrackFromChecked() {
    if (!this.rangeTrack) return;

    let checkedVals = this.checkboxes
      .filter((cb) => cb.checked)
      .map((cb) => parseFloat(cb.value));

    if (checkedVals.length === 0) {
      checkedVals = [
        parseFloat(this.minSlider.value),
        parseFloat(this.maxSlider.value),
      ];
    }

    const minVal = parseFloat(this.minSlider.value);
    const maxVal = parseFloat(this.maxSlider.value);

    const left = Math.round(((minVal - this.minAttr) / this.span) * 100);
    const right = Math.round(100 - ((maxVal - this.minAttr) / this.span) * 100);

    this.rangeTrack.style.left = `${left}%`;
    this.rangeTrack.style.right = `${right}%`;
  }

  updateLabels() {
    const minVal = parseFloat(this.minSlider.value);
    const maxVal = parseFloat(this.maxSlider.value);
    const minLabel = this.querySelector('[data-min-value]');
    const maxLabel = this.querySelector('[data-max-value]');

    minLabel.innerHTML = minVal.toFixed(3);
    maxLabel.innerHTML = maxVal.toFixed(3);
  }

handleSliderChange(e) {
  const minVal = parseFloat(this.minSlider.value);
  const maxVal = parseFloat(this.maxSlider.value);

  if (maxVal - minVal < this.step) {
    const clampedMin = Math.max(this.minAttr, maxVal - this.step);
    const clampedMax = Math.min(this.maxAttr, minVal + this.step);

    if (e?.target === this.minSlider) {
      this.minSlider.value = clampedMin.toString();
    } else {
      this.maxSlider.value = clampedMax.toString();
    }
  }

  this.updateCheckboxes();           // ✅ Visual state
  this.updateTrackFromChecked();     // ✅ Slider fill
  this.updateLabels();               // ✅ Label updates

  if (!this.isDragging) {
    this.updateURLFromCheckedThicknesses(); // 🟢 Trigger Shopify filtering only after drag ends
  }
}

updateURLFromCheckedThicknesses() {
  const params = new URLSearchParams(window.location.search);

  // Clear old thickness filters
  [...params.keys()].forEach((key) => {
    if (key === 'filter.v.m.custom.thickness' || key === 'filter.v.m.vegas_forge.thickness') {
      params.delete(key);
    }
  });

  // Add current ones
  this.checkboxes
    .filter((cb) => cb.checked)
    .forEach((cb) => {
     params.append(cb.name, cb.value);
    });

  // Update browser history
  history.replaceState(null, '', `${window.location.pathname}?${params.toString()}`);

 
  // Trigger Shopify facet refresh
  if (typeof FacetFiltersForm !== 'undefined') {
    FacetFiltersForm.renderPage(params.toString(), null);
  } else {
    // Fallback: reload the page if Shopify's facet system isn't available
    window.location.href = `${window.location.pathname}?${params.toString()}`;
  }
   
}



}


customElements.define('thickness-range', ThicknessRange);
